import script from "./ThemeTogglerComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./ThemeTogglerComponent.vue?vue&type=script&setup=true&lang=js"

import "./ThemeTogglerComponent.vue?vue&type=style&index=0&id=23d3d3f0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23d3d3f0"]])

export default __exports__